import { setLocale, setEmbedded } from '@/helpers/Utils';
import {} from '@/helpers/WorkspaceHelper';
import {
	CHANGE_LOCALE,
	CHANGE_LOADING,
	CHANGE_EMBEDDED,
	CHANGE_DIRTY,
} from '../actions-registry';

export const changeLocale = (payload) => {
	setLocale(payload);
	return {
		type: CHANGE_LOCALE,
		payload,
	};
};
export const changeLoading = (payload) => {
	return {
		type: CHANGE_LOADING,
		payload,
	};
};
export const changeEmbedded = (payload) => {
	setEmbedded(payload);
	return {
		type: CHANGE_EMBEDDED,
		payload,
	};
};
export const changeDirty = (payload) => {
	return {
		type: CHANGE_DIRTY,
		payload,
	};
};
